<img
  [src]="eventImage ?? './../../../../assets/images/evento-sem-imagem.svg'"
  alt="Banner do evento"
  [class.finished]="isEventFinished" />
